import { createContext } from "react";
export const UxContextComponent = createContext({});
